module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "editProjectDialog",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('form', {
    attrs: {
      "id": "editProjectForm"
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("\n            ×\n          ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.dialogTitle))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "panel-group",
    attrs: {
      "id": "accordionEditProject",
      "role": "tablist",
      "aria-multiselectable": "true"
    }
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading",
    attrs: {
      "role": "button",
      "id": "headingEditProjectGeneral",
      "data-toggle": "collapse",
      "data-parent": "#accordionEditProject",
      "href": "#collapseEditProjectGeneral",
      "aria-expanded": "true",
      "aria-controls": "collapseEditProjectGeneral"
    }
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    staticClass: "collapsed"
  }, [_vm._v(_vm._s(_vm.lang.P1000))])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse in",
    attrs: {
      "id": "collapseEditProjectGeneral",
      "role": "tabpanel",
      "aria-labelledby": "headingEditProjectGeneral"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputName"
    }
  }, [_vm._v(_vm._s(_vm.lang.P1001) + "*")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.projectData.ProjectName),
      expression: "projectData.ProjectName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputName",
      "name": "inputName",
      "required": ""
    },
    domProps: {
      "value": (_vm.projectData.ProjectName)
    },
    on: {
      "keyup": function($event) {
        return _vm.validateInput('inputName')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.projectData, "ProjectName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('inputName')),
      expression: "inputHasError('inputName')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.P1002))])])]), _vm._v(" "), (
    !_vm.feature.isAudiTarget ||
    !_vm.feature.isEnabled('audi_importers')
  ) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "editProjectClientSelect"
    }
  }, [_vm._v(_vm._s(_vm.lang.P1003) + "*")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select2', {
    staticClass: "form-control",
    attrs: {
      "id": "editProjectClientSelect",
      "placeholder": _vm.lang.P1004,
      "disabled": !_vm.dialogModeAdd,
      "required": ""
    },
    on: {
      "change": function($event) {
        return _vm.getAvailableSurveysForClient()
      }
    },
    model: {
      value: (_vm.projectData.ClientId),
      callback: function($$v) {
        _vm.$set(_vm.projectData, "ClientId", $$v)
      },
      expression: "projectData.ClientId"
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.clientList), function(client) {
    return _c('option', {
      key: client.ClientId,
      domProps: {
        "value": parseInt(client.ClientId)
      }
    }, [_vm._v("\n                          " + _vm._s(client.ClientName) + "\n                        ")])
  })], 2), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('editProjectClientSelect')),
      expression: "inputHasError('editProjectClientSelect')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.P1002))])], 1)]) : _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "editProjectImporterSelect"
    }
  }, [_vm._v(_vm._s(_vm.lang.P1036) + "*")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select2', {
    staticClass: "form-control",
    attrs: {
      "id": "editProjectImporterSelect",
      "placeholder": _vm.lang.P1004,
      "required": ""
    },
    model: {
      value: (_vm.projectData.ImporterGuid),
      callback: function($$v) {
        _vm.$set(_vm.projectData, "ImporterGuid", $$v)
      },
      expression: "projectData.ImporterGuid"
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.importerList), function(importer) {
    return _c('option', {
      key: importer.ImporterGuid,
      domProps: {
        "value": importer.ImporterGuid
      }
    }, [_vm._v("\n                          " + _vm._s(importer.ImporterName) + "\n                        ")])
  })], 2), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('editProjectImporterSelect')),
      expression: "inputHasError('editProjectImporterSelect')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.P1002))])], 1)]), _vm._v(" "), (!_vm.feature.isAudiTarget) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputProjectAccountable"
    }
  }, [_vm._v(_vm._s(_vm.lang.P1022) + "*")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select2', {
    staticClass: "form-control",
    attrs: {
      "id": "inputProjectAccountable",
      "placeholder": _vm.lang.P1004,
      "required": ""
    },
    model: {
      value: (_vm.projectData.ProjectAccountableGuid),
      callback: function($$v) {
        _vm.$set(_vm.projectData, "ProjectAccountableGuid", $$v)
      },
      expression: "projectData.ProjectAccountableGuid"
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.listOfProjectAccountables), function(accountable, guid) {
    return _c('option', {
      key: guid,
      domProps: {
        "value": guid
      }
    }, [_vm._v("\n                          " + _vm._s(accountable) + "\n                        ")])
  })], 2), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('inputProjectAccountable')),
      expression: "inputHasError('inputProjectAccountable')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.P1002))])], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputProjectSince"
    }
  }, [_vm._v(_vm._s(_vm.lang.P1015))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10",
    on: {
      "click": function($event) {
        return _vm.globals.toggleFlatpickr('inputProjectSince')
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.projectData.ProjectSince),
      expression: "projectData.ProjectSince"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputProjectSince",
      "name": "inputProjectSince"
    },
    domProps: {
      "value": (_vm.projectData.ProjectSince)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.projectData, "ProjectSince", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputProjectUntil"
    }
  }, [_vm._v(_vm._s(_vm.lang.P1016))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10",
    on: {
      "click": function($event) {
        return _vm.globals.toggleFlatpickr('inputProjectUntil')
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.projectData.ProjectUntil),
      expression: "projectData.ProjectUntil"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputProjectUntil",
      "name": "inputProjectUntil"
    },
    domProps: {
      "value": (_vm.projectData.ProjectUntil)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.projectData, "ProjectUntil", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-heading",
    attrs: {
      "role": "button",
      "id": "headingEditProjectSurveys",
      "data-toggle": "collapse",
      "data-parent": "#accordionEditProject",
      "href": "#collapseEditProjectSurveys",
      "aria-expanded": "false",
      "aria-controls": "collapseEditProjectSurveys"
    }
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    staticClass: "collapsed"
  }, [_vm._v(_vm._s(_vm.lang.P1005))])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse",
    attrs: {
      "id": "collapseEditProjectSurveys",
      "role": "tabpanel",
      "aria-labelledby": "headingEditProjectSurveys"
    }
  }, [_c('div', {
    staticClass: "panel-body",
    staticStyle: {
      "padding": "15px"
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('a', {
    staticClass: "btn btn-fab btn-fab-mini dialog-btn-primary",
    attrs: {
      "role": "button",
      "disabled": _vm.selectedAssignedSurveyIds.length == 0
    },
    on: {
      "click": function($event) {
        return _vm.unassignSurveys()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("arrow_back")])]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-fab btn-fab-mini dialog-btn-primary",
    attrs: {
      "id": "assignSurveysButton",
      "role": "button",
      "disabled": _vm.selectedUnassignedSurveyIds.length == 0
    },
    on: {
      "click": function($event) {
        return _vm.assignSurveys()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("arrow_forward")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('table', {
    staticClass: "table table-striped table-hover",
    attrs: {
      "id": "availableSurveys"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.lang.P1006))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.getUnassignedSurveys()), function(survey) {
    return _c('tr', {
      key: survey.SurveyId,
      class: {
        info: _vm.selectedUnassignedSurveyIds.indexOf(
          survey.SurveyId
        ) > -1,
      },
      attrs: {
        "role": "button"
      },
      on: {
        "click": function($event) {
          return _vm.toggleListItem(
            _vm.selectedUnassignedSurveyIds,
            survey.SurveyId
          )
        },
        "dblclick": function($event) {
          (_vm.selectedUnassignedSurveyIds = []),
          _vm.toggleSurveyListItem(
            _vm.projectData.Surveys,
            survey.SurveyId
          )
        }
      }
    }, [_c('td', [_vm._v(_vm._s(survey.SurveyTitle))])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('table', {
    staticClass: "table table-striped table-hover"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "80%"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.lang.P1007) + "\n                          ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.lang.P1014) + "\n                          ")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.getAssignedSurveys()), function(survey) {
    return _c('tr', {
      key: survey.SurveyId,
      class: {
        info: _vm.selectedAssignedSurveyIds.indexOf(
          survey.SurveyId
        ) > -1,
      },
      attrs: {
        "role": "button"
      },
      on: {
        "click": function($event) {
          return _vm.toggleListItem(
            _vm.selectedAssignedSurveyIds,
            survey.SurveyId
          )
        },
        "dblclick": function($event) {
          (_vm.selectedAssignedSurveyIds = []),
          _vm.toggleSurveyListItem(
            _vm.projectData.Surveys,
            survey.SurveyId
          )
        }
      }
    }, [_c('td', {
      staticStyle: {
        "width": "80%"
      }
    }, [_vm._v("\n                            " + _vm._s(survey.SurveyTitle) + "\n                          ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "20%",
        "padding": "5px"
      }
    }, [_c('div', {
      staticClass: "checkbox",
      staticStyle: {
        "margin": "0px"
      }
    }, [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (
          _vm.projectData.Surveys[
            _vm.getIndexOfSurveyInProjectDataSurveys(
              survey.SurveyId
            )
          ].ReportingVisibility
        ),
        expression: "\n                                    projectData.Surveys[\n                                      getIndexOfSurveyInProjectDataSurveys(\n                                        survey.SurveyId\n                                      )\n                                    ].ReportingVisibility\n                                  "
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(
          _vm.projectData.Surveys[
            _vm.getIndexOfSurveyInProjectDataSurveys(
              survey.SurveyId
            )
          ].ReportingVisibility
        ) ? _vm._i(
          _vm.projectData.Surveys[
            _vm.getIndexOfSurveyInProjectDataSurveys(
              survey.SurveyId
            )
          ].ReportingVisibility, null) > -1 : (
          _vm.projectData.Surveys[
            _vm.getIndexOfSurveyInProjectDataSurveys(
              survey.SurveyId
            )
          ].ReportingVisibility
        )
      },
      on: {
        "change": [function($event) {
          var $$a =
            _vm.projectData.Surveys[
              _vm.getIndexOfSurveyInProjectDataSurveys(
                survey.SurveyId
              )
            ].ReportingVisibility,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.projectData.Surveys[
                _vm.getIndexOfSurveyInProjectDataSurveys(
                  survey.SurveyId
                )
              ], "ReportingVisibility", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.projectData.Surveys[
                _vm.getIndexOfSurveyInProjectDataSurveys(
                  survey.SurveyId
                )
              ], "ReportingVisibility", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.projectData.Surveys[
              _vm.getIndexOfSurveyInProjectDataSurveys(
                survey.SurveyId
              )
            ], "ReportingVisibility", $$c)
          }
        }, function($event) {
          _vm.surveyReportingVisibilityChanged(
            _vm.projectData.Surveys[
              _vm.getIndexOfSurveyInProjectDataSurveys(
                survey.SurveyId
              )
            ]
          )
        }]
      }
    }), _vm._v(" "), _vm._m(0, true)])])])])
  }), 0)])])])]), _vm._v(" "), (_vm.feature.isEnabled('briefingAndSurveyDocs')) ? _c('div', {
    staticClass: "panel-heading",
    attrs: {
      "role": "button",
      "id": "headingEditProjectSurveys",
      "data-toggle": "collapse",
      "data-parent": "#accordionEditProject",
      "href": "#collapseEditProjectDocuments",
      "aria-expanded": "false",
      "aria-controls": "collapseEditProjectDocuments"
    }
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    staticClass: "collapsed"
  }, [_vm._v(_vm._s(_vm.lang.P1023))])])]) : _vm._e(), _vm._v(" "), (_vm.feature.isEnabled('briefingAndSurveyDocs')) ? _c('div', {
    staticClass: "panel-collapse collapse",
    attrs: {
      "id": "collapseEditProjectDocuments",
      "role": "tabpanel",
      "aria-labelledby": "headingEditProjectSurveys"
    }
  }, [_c('div', {
    staticClass: "panel-body",
    staticStyle: {
      "padding": "15px"
    }
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group form-group-files"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputBriefingAttachmentFile"
    }
  }, [_vm._v(_vm._s(_vm.lang.P1024))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    staticClass: "form-control",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "id": "inputBriefingAttachmentFile",
      "type": "file",
      "accept": "application/pdf",
      "title": _vm.lang.P1025
    },
    on: {
      "change": _vm.onBriefingAttachmentFileChange
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    staticStyle: {
      "padding-top": "12px"
    }
  }, [_vm._v(_vm._s(_vm.lang.P1026))]), _vm._v(" "), _vm._m(1)])])]), _vm._v(" "), _c('table', {
    staticClass: "table table-striped table-hover",
    staticStyle: {
      "margin": "0px"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "60%"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.lang.P1029) + "\n                          ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.lang.P1030) + "\n                          ")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.briefings), function(briefing, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(briefing.FileName))]), _vm._v(" "), _c('td', {
      staticClass: "nopadding"
    }, [_c('div', {
      staticStyle: {
        "float": "none"
      }
    }, [_c('button', {
      staticClass: "btn",
      staticStyle: {
        "padding": "0px",
        "margin": "7px"
      },
      attrs: {
        "type": "button",
        "title": _vm.lang.P1027,
        "disabled": !briefing.DownloadId
      },
      on: {
        "click": function($event) {
          return _vm.globals.downloadFile(briefing.DownloadId)
        }
      }
    }, [_c('i', {
      staticClass: "material-icons text-green"
    }, [_vm._v("file_download")])]), _vm._v(" "), _c('button', {
      staticClass: "btn",
      staticStyle: {
        "padding": "0px",
        "margin": "7px"
      },
      attrs: {
        "type": "button",
        "title": _vm.lang.P1028,
        "disabled": !briefing.DownloadId
      },
      on: {
        "click": function($event) {
          return _vm.removeAttachmentFile(_vm.briefings, index)
        }
      }
    }, [_c('i', {
      staticClass: "material-icons text-red"
    }, [_vm._v("clear")])])])])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group form-group-files"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputSurveyAttachmentFile"
    }
  }, [_vm._v(_vm._s(_vm.lang.P1031))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    staticClass: "form-control",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "id": "inputSurveyAttachmentFile",
      "type": "file",
      "accept": "application/pdf",
      "title": _vm.lang.P1032
    },
    on: {
      "change": _vm.onSurveyAttachmentFileChange
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    staticStyle: {
      "padding-top": "12px"
    }
  }, [_vm._v(_vm._s(_vm.lang.P1033))]), _vm._v(" "), _vm._m(2)])])]), _vm._v(" "), _c('table', {
    staticClass: "table table-striped table-hover",
    staticStyle: {
      "margin": "0px"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "60%"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.lang.P1029) + "\n                          ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.lang.P1030) + "\n                          ")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.surveys), function(survey, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(survey.FileName))]), _vm._v(" "), _c('td', {
      staticClass: "nopadding"
    }, [_c('div', {
      staticStyle: {
        "float": "none"
      }
    }, [_c('button', {
      staticClass: "btn",
      staticStyle: {
        "padding": "0px",
        "margin": "7px"
      },
      attrs: {
        "type": "button",
        "title": _vm.lang.P1034,
        "disabled": !survey.DownloadId
      },
      on: {
        "click": function($event) {
          return _vm.globals.downloadFile(survey.DownloadId)
        }
      }
    }, [_c('i', {
      staticClass: "material-icons text-green"
    }, [_vm._v("file_download")])]), _vm._v(" "), _c('button', {
      staticClass: "btn",
      staticStyle: {
        "padding": "0px",
        "margin": "7px"
      },
      attrs: {
        "type": "button",
        "title": _vm.lang.P1035,
        "disabled": !survey.DownloadId
      },
      on: {
        "click": function($event) {
          return _vm.removeAttachmentFile(_vm.surveys, index)
        }
      }
    }, [_c('i', {
      staticClass: "material-icons text-red"
    }, [_vm._v("clear")])])])])])
  }), 0)])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "panel-heading",
    attrs: {
      "role": "button",
      "id": "headingEditProjectPlanning",
      "data-toggle": "collapse",
      "data-parent": "#accordionEditProject",
      "href": "#collapseEditProjectPlanning",
      "aria-expanded": "false",
      "aria-controls": "collapseEditProjectPlanning"
    }
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    staticClass: "collapsed"
  }, [_vm._v(_vm._s(_vm.lang.P1008))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isGanttVisible),
      expression: "isGanttVisible"
    }],
    attrs: {
      "id": "zoomButtonBar"
    }
  }, [_c('a', {
    staticClass: "btn text-primary nopadding",
    attrs: {
      "role": "button",
      "title": "Zoom out",
      "disabled": _vm.currentScaleUnit == 'year'
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.zoomGanttChart(false)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("remove")])]), _vm._v(" "), _c('a', {
    staticClass: "btn text-primary nopadding",
    attrs: {
      "role": "button",
      "title": "Zoom in",
      "disabled": _vm.currentScaleUnit == 'week'
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.zoomGanttChart(true)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("add")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse",
    attrs: {
      "id": "collapseEditProjectPlanning",
      "role": "tabpanel",
      "aria-labelledby": "headingEditProjectPlanning"
    }
  }, [_c('div', {
    staticClass: "panel-body",
    staticStyle: {
      "padding": "15px"
    }
  }, [_c('div', {
    staticClass: "container gantt-container"
  }, [_c('gantt', {
    ref: "pmGantt",
    staticClass: "left-container",
    attrs: {
      "id": "pmGantt",
      "tasks": _vm.projectData.Gantt
    },
    on: {
      "task-updated": _vm.updateGanttTask
    }
  })], 1)])])])]), _vm._v(" "), _c('b-alert', {
    attrs: {
      "variant": "danger",
      "dismissible": "",
      "show": _vm.showAlert
    },
    on: {
      "dismissed": function($event) {
        _vm.showAlert = false
      }
    }
  }, [_vm._v(_vm._s(_vm.lang.P1009))])], 1), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.P1010) + "\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised dialog-btn-primary",
    attrs: {
      "id": "project-management-edit-modal-save-button",
      "type": "button",
      "disabled": !_vm.globals.isAccessAllowed('LoopOp_Projects_Update') &&
        !_vm.dialogModeAdd
    },
    on: {
      "click": function($event) {
        return _vm.validateBeforeSubmit('editProjectDialog')
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.P1011) + "\n          ")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "checkbox-material"
  }, [_c('span', {
    staticClass: "check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-btn input-group-sm"
  }, [_c('button', {
    staticClass: "btn btn-fab btn-fab-mini",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("attach_file")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-btn input-group-sm"
  }, [_c('button', {
    staticClass: "btn btn-fab btn-fab-mini",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("attach_file")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-48c21c08","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProjectManagement/ProjectManagementEditModal.vue
// module id = 1677
// module chunks = 1